/* eslint-disable quote-props */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Box, Button, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Card, CardContent, CardActions,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useNavigate } from 'react-router-dom';

// const invoiceSubtotal = subtotal(12);
// const invoiceTaxes = TAX_RATE * invoiceSubtotal;
// const invoiceTotal = invoiceTaxes + invoiceSubtotal;

const TranscriptCalculator = () => {
  const [newData, setNewData] = useState(JSON.parse(localStorage.getItem('data')));
  const [expressData, setExpressData] = useState(false);
  const [timeCode, setTimeCode] = useState(false);
  const [verbatim, setVerbatim] = useState(false);
  // Object for price and extra services start
  const [extraInfo, setExtraInfo] = useState({
    express: false,
    timeStamps: false,
    verbatimStyle: false,
  });

  // Object for price and extra services end
  const navigate = useNavigate();

  const handleExpress = (e) => {
    setExpressData(e.target.checked);
    if (expressData === true) {
      return calcExpress(newData[0].duration);
    }
    return calcExpress();
  };

  const handleTimeCode = (e) => {
    setTimeCode(e.target.checked);
    if (timeCode === true) {
      return calcTimeCodes(newData[0].duration);
    }
    return calcTimeCodes();
  };

  const handleVerbatim = (e) => {
    setVerbatim(e.target.checked);
    if (verbatim === true) {
      return calcVerbatim(newData[0].duration);
    }
    return calcVerbatim();
  };

  // Find SubTotal
  const calcSubTotal = (duration) => duration * 1.5;

  // Find Express Orders
  const calcExpress = (duration = 0) => duration * 1.25;

  // Find Time Codes
  const calcTimeCodes = (duration = 0) => duration * 0.30;

  // Find Verbatim
  const calcVerbatim = (duration = 0) => duration * 0.50;

  // Cal Total
  const calcTotal = () => calcSubTotal(newData[0].duration) + (expressData ? calcExpress(newData[0].duration) : calcExpress()) + (timeCode ? calcTimeCodes(newData[0].duration) : calcTimeCodes()) + (verbatim ? calcVerbatim(newData[0].duration) : calcVerbatim());

  // SET (calcTotal()).toFixed(2) to localStorage
  localStorage.setItem('moreInfo', JSON.stringify({
    price: (calcTotal()).toFixed(2),
    expressOrder: expressData ? 'YES' : 'NO',
    timeStamps: timeCode ? 'YES' : 'NO',
    verbatimStyle: verbatim ? 'YES' : 'NO',
  }));

  // DPO API HERE

  const headersList = {
    'Accept': '*/*',
    'Content-Type': 'application/xml',
  };

  const bodyContent = `<?xml version="1.0" encoding="utf-8"?>\n<API3G>\n<CompanyToken>8D3DA73D-9D7F-4E09-96D4-3D44E7A83EA3</CompanyToken>\n<Request>createToken</Request>\n<Transaction>\n<PaymentAmount>${(calcTotal()).toFixed(2)}</PaymentAmount>\n<PaymentCurrency>USD</PaymentCurrency>\n</Transaction>\n<Services>\n  <Service>\n      <ServiceType>3854</ServiceType>\n    <ServiceDescription>Transcription Services</ServiceDescription>\n    <ServiceDate>${new Date()}</ServiceDate>\n  </Service>\n</Services>\n</API3G>`;

  const handleCheckout = async () => {
    const response = await fetch('https://secure.3gdirectpay.com/API/v6/', {
      method: 'POST',
      body: bodyContent,
      headers: headersList,
    });
    const data = await response;
    console.log(data);
  };

  // END DPO API TESTING

  return (
    <Box sx={{
      height: { xs: '100%', sm: '100vh' }, width: '100%', backgroundColor: '#F5F8FA', padding: { xs: '20px 250px', sm: '40px 250px' }, display: 'flex', flexDirection: 'column', justifyContent: { xs: 'stretch', sm: 'center' }, alignItems: { xs: 'stretch', sm: 'center' },
    }}
    >
      <Box sx={{
        width: '100%', margin: '10px 0', display: 'flex', flexDirection: 'column', justifyContent: { xs: 'stretch', sm: 'center' }, alignItems: { xs: 'stretch', sm: 'center' },
      }}
      >
        <Typography sx={{
          fontWeight: '500', fontSize: { xs: '28px', sm: '30px' }, color: '#717A82', lineHeight: { xs: '30px', sm: '50px' },
        }}
        >
          Order English Transcripts by a Professional Transcriber
        </Typography>
        <Typography sx={{
          fontWeight: '300', fontSize: { xs: '15px', sm: '18px' }, color: '#717A82', lineHeight: { xs: '30px', sm: '50px' },
        }}
        >
          Professionals transcribe your files with 99% accuracy
        </Typography>
      </Box>
      <Box sx={{
        width: '100%', marginBottom: '50px', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', alignItems: { xs: 'stretch', sm: 'center' },
      }}
      >
        <Button variant="outlined" onClick={() => navigate('/')}>Back To Website</Button>
      </Box>
      <Box sx={{
        width: '100%', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', alignItems: 'center', gap: { xs: '18px', sm: '20px' },
      }}
      >
        <Box>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: { xs: 400, sm: 700 } }} aria-label="spanning table">
              <TableHead>
                <TableRow>
                  <TableCell>File Name/URL</TableCell>
                  <TableCell align="left">Est. Delivery</TableCell>
                  <TableCell align="left">Cost</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {newData && newData.map((data) => (
                  <TableRow key={data.id}>
                    <TableCell variant="a" target="_blank" component="a" href={data.url} sx={{ fontWeight: '300', fontSize: '15px', lineHeight: '20px' }}>
                      {data.name.substring(0, 15)}
                      {' '}
                      |
                      {' '}
                      <span style={{ color: '#000' }}>
                        {data.duration}
                        {' '}
                        min
                      </span>
                    </TableCell>
                    <TableCell sx={{ fontWeight: '300', fontSize: '15px', lineHeight: '20px' }} align="left">3 hrs</TableCell>
                    <TableCell sx={{ fontWeight: '300', fontSize: '15px', lineHeight: '20px' }} align="left">
                      $
                      {(calcSubTotal(data.duration)).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}

                <TableRow>
                  <TableCell sx={{ fontWeight: '500' }} colSpan={2}>SUBTOTAL ($1.50/MIN) </TableCell>
                  <TableCell sx={{ fontWeight: '500' }} align="left">
                    $
                    {(calcSubTotal(newData[0].duration)).toFixed(2)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: '300', fontSize: '15px', lineHeight: '20px' }} colSpan={2}>
                    <input type="checkbox" onChange={(e) => handleExpress(e)} name="express" checked={expressData} />
                    {' '}
                    Express Ordering (+ $1.25/min) - Delivered in 6hrs
                  </TableCell>
                  <TableCell sx={{ fontWeight: '300', fontSize: '15px', lineHeight: '20px' }} align="left">
                    $
                    {expressData ? (calcExpress(newData[0].duration)).toFixed(2) : (calcExpress()).toFixed(2)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: '300', fontSize: '15px', lineHeight: '20px' }} colSpan={2}>
                    <input type="checkbox" onChange={(e) => handleTimeCode(e)} name="timeStamps" checked={timeCode} />
                    {' '}
                    Timestamping (+ $0.30/min) - Transcript synced to audio with timestamps
                  </TableCell>
                  <TableCell sx={{ fontWeight: '300', fontSize: '15px', lineHeight: '20px' }} align="left">
                    $
                    {timeCode ? (calcTimeCodes(newData[0].duration)).toFixed(2) : (calcTimeCodes()).toFixed(2)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: '300', fontSize: '15px', lineHeight: '20px' }} colSpan={2}>
                    <input type="checkbox" onChange={(e) => handleVerbatim(e)} name="verbatimStyle" checked={verbatim} />
                    {' '}
                    Verbatim (+ $0.50/min) - Include filler words, nonverbal communication, and false starts.
                  </TableCell>
                  <TableCell sx={{ fontWeight: '300', fontSize: '15px', lineHeight: '20px' }} align="left">
                    $
                    {verbatim ? (calcVerbatim(newData[0].duration)).toFixed(2) : (calcVerbatim()).toFixed(2)}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: '500' }} colSpan={2}>ORDER TOTAL</TableCell>
                  <TableCell sx={{ fontWeight: '500' }} align="left">
                    $
                    {(calcTotal()).toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box>
          <Card sx={{ width: '100%' }}>
            <CardContent sx={{
              width: '100%', display: 'flex', flexDirection: 'row', gap: '100px',
            }}
            >
              <Typography sx={{
                width: '100%', fontWeight: '600', fontSize: '18px', lineHeight: '20px',
              }}
              >
                Total
              </Typography>
              <Typography sx={{
                width: '100%', fontWeight: '600', fontSize: '18px', lineHeight: '20px',
              }}
              >
                $
                {(calcTotal()).toFixed(2)}
              </Typography>
            </CardContent>
            <CardActions sx={{ width: '100%' }}>
              <Button sx={{ width: '100%' }} onClick={handleCheckout} variant="contained">CHECKOUT</Button>
            </CardActions>
          </Card>
          <Typography sx={{
            width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '10px auto',
          }}
          >
            <LockOutlinedIcon />
            {' '}
            Secure and Encrypted
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default TranscriptCalculator;

// // SET ADDITIONAL SERVICES TO LOCALSTORAGE
// expressData && localStorage.setItem("express", JSON.stringify("Express Order"));

// // SET ADDITIONAL SERVICES TO LOCALSTORAGE
// timeCode && localStorage.setItem("timeStamps", JSON.stringify("Add Timetamps"));

// // SET ADDITIONAL SERVICES TO LOCALSTORAGE
// verbatim && localStorage.setItem("verbatim", JSON.stringify("Full Verbatim"));

// SET (calcTotal()).toFixed(2) to localStorage
// localStorage.setItem("price", JSON.stringify((calcTotal()).toFixed(2)));
// () => navigate('/proceed_with_transcription_order')
